import { Colors, Img, Lightning, Utils } from '@lightningjs/sdk'
import { isString } from '../../lib/AppHelpers'
// import MovingTitle from "../MovingTitle";

export default class GridCover extends Lightning.Component {
  static _template() {
    return {
      w: 360,
      h: 400,
      CoverWrapper: {
        w: 340,
        h: 340,
        pivotX: 0.5,
        pivotY: 1,
        // CoverShadow: {w: 360, h: 360, alpha: 0.001, texture: Lightning.Tools.getShadowRect(360, 360, 5, 17, 19), color: Colors('black').get()},
        CoverImageWrapper: {
          w: 340,
          h: 340,
          // Default: {w: 340, h: 340}, // , src: Utils.asset('images/covers/ImagePlaceHolder.jpg')
          CoverBG: { w: 340, h: 340 },
          Cover: { w: 340, h: 340 },
        },
        CoverBorder: {
          w: 340,
          h: 340,
          rect: true,
          shader: {
            radius: 0,
            stroke: 5,
            strokeColor: Colors('border')
              .alpha(0)
              .get(),
            fill: false,
            fillColor: 0x00000000,
            type: Lightning.shaders.RoundedRectangle,
          },
        },
      },
      Title: {
        w: 340,
        h: 60,
        x: 5,
        y: 340,
        color: Colors('white').get(),
        alpha: 1,
        text: {
          text: '',
          verticalAlign: 'middle',
          fontSize: 25,
          fontFace: 'OpenSansRegular',
          lineHeight: 35,
          maxLines: 1,
          wordWrapWidth: 340,
          textOverflow: 'ellipsis',
        },
      },
      // MovingTitle: {w: 360, h: 60, x: -5, y: 340, type: MovingTitle, fontSize: {sz: 30}, fontFace: 'OpenSansBold', alpha: 0.001}
    }
  }

  set item(itm) {
    this._item = itm
  }

  get item() {
    return this._item
  }
  set bgImage(itm) {
    this._bgImage = itm
  }

  _init() {
    // this.tag('Default').alpha = 1
    // this.tag('CoverBG').on('txLoaded', () => {
    // this.tag('Default').alpha = 0
    // this.tag('CoverShadow').patch({
    // 	smooth: {alpha: [0.3, {duration: 3, delay: 0.2, timingFunction: 'ease-out'}]}
    // });
    // });

    this.tag('Cover').on('txError', () => {
      this.tag('Cover').src = Utils.asset('images/covers/ImagePlaceHolder.jpg')
    })
    // this.tag("CoverWrapper").transition('scale').on('finish', () => {
    // 	this.tag("MovingTitle").start();
    // });
  }

  _firstActive() {
    this._update()
  }

  _update() {
    this.patch({
      w: 360,
      h: 400,
      CoverWrapper: {
        pivotX: this.x === 0 ? 0 : 0.5,
        // CoverShadow: {alpha: 0.2},
        CoverImageWrapper: {
          CoverBG: {
            texture: Img(
              this._bgImage ? this._bgImage : Utils.asset('images/covers/ImagePlaceHolder.jpg')
            ).cover(340 / 2, 340 / 2),
          }, // todo resize to original
          Cover: { texture: Img(this._item.imageUrl).cover(340 / 2, 340 / 2) }, // todo resize to original
        },
      },
      Title: { text: { text: this._item.title } },
      // MovingTitle: {title: this._item.title || ''}
    })

    if (this._item.imageUrl === undefined || !isString(this._item.imageUrl)) {
      this.tag('Cover').src = Utils.asset('images/covers/ImagePlaceHolder.jpg')
    }
  }

  _focus() {
    this._moveTitle = true

    this.patch({
      CoverWrapper: {
        smooth: {
          scale: [1.05, { duration: 0.3, delay: 0.1, timingFunction: 'ease-out' }],
        },
        // CoverShadow: {
        // 	smooth: {alpha: [0.6, {duration: 0.3, delay: 0.2, timingFunction: 'ease-out'}]}
        // },
        CoverBorder: {
          smooth: {
            'shader.strokeColor': [
              Colors('border')
                .alpha(1)
                .get(),
              { duration: 0.4, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      Title: {
        text: { fontSize: 30, fontFace: 'OpenSansBold' },
      },
      // MovingTitle: {smooth: {alpha: [1, {duration: 0.3, delay: 0.3, timingFunction: 'ease-out'}]}}
    })
  }

  _unfocus() {
    this._moveTitle = false

    this.patch({
      CoverWrapper: {
        smooth: {
          scale: [1, { duration: 0.2, delay: 0.2, timingFunction: 'ease-out' }],
        },
        // CoverShadow: {
        // 	smooth: {alpha: [0.2, {duration: 0.3, delay: 0.1, timingFunction: 'ease-out'}]}
        // },
        CoverBorder: {
          smooth: {
            'shader.strokeColor': [
              Colors('border')
                .alpha(0)
                .get(),
              { duration: 0.4, timingFunction: 'ease-in' },
            ],
          },
        },
      },
      Title: {
        text: { fontSize: 25, fontFace: 'OpenSansRegular' },
      },
      // MovingTitle: {smooth: {alpha: [0, {duration: 0.3, delay: 0.1, timingFunction: 'ease-out'}]}}
    })

    // this.tag("MovingTitle").stop();
  }
}
